import React from "react";
import { useDrop } from "react-dnd";
import { QuestionType } from "../Template/Template";
import Skeleton from "react-loading-skeleton";

require("./QuestionsColumn.scss");

type Props = {
  items?: QuestionType[];
  children: React.ReactNode;
  className: string;
  title: string;
  style?: React.CSSProperties;
  lenghtItems: number;
  isLoading: boolean;
};

export const QuestionColumn = ({
  items,
  children,
  className,
  title,
  lenghtItems,
  isLoading,
  style,
}: Props) => {
  const [, drop] = useDrop({
    accept: "Question",
    drop: () => ({ id: title }),
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
    // Override monitor.canDrop() function
    /* canDrop: (item: MovableItemType) => {
      const { currentColumnName } = item;
      const columnLength = items
        ? items.filter(({ column }: Partial<QuestionType>) => column === title)
            .length
        : 0;
      return title !== currentColumnName && columnLength < 10;
    }, */
  });
  return (
    <div
      id={`id-${className}`}
      ref={drop}
      style={style}
      className={`${className} wrapper-questions-column`}
    >
      {lenghtItems > 0 || title !== "template" ? (
        <>
          {children}
          {isLoading && (
            <Skeleton style={{ marginBottom: "10px" }} count={5} height={112} />
          )}
        </>
      ) : (
        <div className="empty-columns">
          <div className="no-items">
            <i className={`icon icon-clipboard`}></i>
            <span className="title-no-items">Trascina una domanda</span>
          </div>
        </div>
      )}
    </div>
  );
};
